import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';
import { useSelectSearchContext } from '../context.mjs';
import { dividerStyle } from '../select.vanilla.mjs';

function SelectSeparator({ className, ...props }) {
  const { renderEmpty } = useSelectSearchContext();
  return /* @__PURE__ */ jsx(
    Legacy_Dropdown.Divider,
    {
      className: classNames(dividerStyle, className),
      ...props,
      hidden: props.hidden ?? renderEmpty
    }
  );
}

export { SelectSeparator };
//# sourceMappingURL=Separator.mjs.map
